import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import reportAxios from '../../../axios/report'

export const reportAppraisalByJobKpi = recordData => {
  return dispatch => {
    dispatch(reportAppraisalByJobKpiStart())

    reportAxios
      .post('/report_appraisal_report_by_kpi', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report Appraisal By Job Kpi',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportAppraisalByJobKpiSuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: 'Error Report Appraisal By Job Kpi',
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportAppraisalByJobKpiFailed())
      })
  }
}

export const reportAppraisalByJobKpiStart = () => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_JOB_KPI_START
  }
}

export const reportAppraisalByJobKpiSuccess = data => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_JOB_KPI_SUCCESS,
    data
  }
}

export const reportAppraisalByJobKpiFailed = () => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_JOB_KPI_FAILED
  }
}

export const clearReportAppraisalByJobKpi = () => {
  return {
    type: actionTypes.CLEAR_REPORT_APPRAISAL_BY_JOB_KPI
  }
}
